import React, { useCallback, useEffect, useState } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import {
  deleteChecklistItem,
  updateChecklistItem,
} from '../../../../../../../../../../app/page/page-storage/checklists/checkLists.actions';

import { IChecklistItemProps } from './types';

export const Item: FunctionComponent<IChecklistItemProps> = ({ checklistItem }) => {
  const dispatch = useDispatch();
  const onDeleteChecklistItem = useCallback(() => {
    dispatch(deleteChecklistItem(checklistItem.id));
  }, [checklistItem.id, dispatch]);

  const [checked, setChecked] = useState(checklistItem.status === '1');
  const [editionMode, setEditionMode] = useState(false);
  const [newCheckListTitle, setNewCheckListTitle] = useState(checklistItem.title);

  const onCheck = () => {
    setChecked(!checked);
  };

  const handleUpdateChecklistKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' || event.key === 'Tab') {
      onEdit();
    }
  };

  const onEdit = () => {
    dispatch(updateChecklistItem(checklistItem.id, { ...checklistItem, title: newCheckListTitle }));
    setEditionMode(false);
  };

  useEffect(() => {
    if ((checklistItem.status === '1') !== checked) {
      dispatch(updateChecklistItem(checklistItem.id, { ...checklistItem, status: checked ? '1' : '0' }));
    }
  }, [checklistItem, checked, dispatch]);

  return (
    <>
      {!editionMode && (
        <div className="checklist-checkbox flex aic py-1 m-0">
          <input type="checkbox" id={`checkBox-${checklistItem.id}`} checked={checked} onChange={onCheck} />
          {/* the label htmlFor attribute is separated to prevent the state of the checklist from changing */}
          <label htmlFor={`checkBox-${checklistItem.id}`} />
          <label className="pt-1" onDoubleClick={(e) => setEditionMode(true)} title="Double click to edit">
            {checklistItem.title}
          </label>
          <span
            className="remove-checklist-item link red f-2 ml-auto remove_checklist_item"
            onClick={onDeleteChecklistItem}
          >
            ×
          </span>
        </div>
      )}

      {editionMode && (
        <div className="checklist-checkbox flex aic py-1 m-0">
          <input
            value={newCheckListTitle}
            onChange={(e) => setNewCheckListTitle(e.target.value)}
            onBlur={onEdit}
            onKeyDown={handleUpdateChecklistKey}
          />
        </div>
      )}
    </>
  );
};
